import { createFileRoute } from '@tanstack/react-router'
import { GoogleShopCardRenderer } from '~/features/ai-assistant/components/genui/google-shop-card-renderer'

export const Route = createFileRoute('/{-$locale}/_dev/test-google-card')({
  component: TestGoogleCardPage,
})

function TestGoogleCardPage() {
  const dummyToolCall = {
    toolCallId: 'call_123',
    toolName: 'render_google_shop_card',
    args: {
      placeId: 'ChIJN1t_tDeuEmsRUsoyG83frY4',
      name: 'Google Shop',
      rating: 4.5,
      openNow: true,
      distanceMeters: 500,
      address: '123 Fake St'
    }
  }

  return (
    <div className="p-8 flex justify-center bg-stone-100 min-h-screen">
      <div id="test-container" className="w-full max-w-sm">
        <GoogleShopCardRenderer 
          toolCall={dummyToolCall}
          addToolResult={() => {}}
        />
      </div>
    </div>
  )
}
